const PIECE_COLORS = [
  '#FF6B6B', // Coral
  '#4ECDC4', // Teal
  '#FFD93D', // Yellow
  '#6BCB77', // Green
  '#4D96FF', // Blue
  '#BB86FC', // Purple
  '#FF8C42', // Orange
  '#FF6B9D', // Pink
];

const PIECE_DEFINITIONS = [
  // Single
  { shape: [[1]], weight: 3 },

  // Lines horizontal
  { shape: [[1, 1]], weight: 4 },
  { shape: [[1, 1, 1]], weight: 4 },
  { shape: [[1, 1, 1, 1]], weight: 2 },
  { shape: [[1, 1, 1, 1, 1]], weight: 1 },

  // Lines vertical
  { shape: [[1], [1]], weight: 4 },
  { shape: [[1], [1], [1]], weight: 4 },
  { shape: [[1], [1], [1], [1]], weight: 2 },
  { shape: [[1], [1], [1], [1], [1]], weight: 1 },

  // Squares
  { shape: [[1, 1], [1, 1]], weight: 4 },
  { shape: [[1, 1, 1], [1, 1, 1], [1, 1, 1]], weight: 1 },

  // L-shapes
  { shape: [[1, 0], [1, 0], [1, 1]], weight: 2 },
  { shape: [[1, 1, 1], [1, 0, 0]], weight: 2 },
  { shape: [[1, 1], [0, 1], [0, 1]], weight: 2 },
  { shape: [[0, 0, 1], [1, 1, 1]], weight: 2 },

  // T-shapes
  { shape: [[1, 1, 1], [0, 1, 0]], weight: 2 },
  { shape: [[0, 1], [1, 1], [0, 1]], weight: 2 },
  { shape: [[0, 1, 0], [1, 1, 1]], weight: 2 },
  { shape: [[1, 0], [1, 1], [1, 0]], weight: 2 },

  // S-shapes
  { shape: [[0, 1, 1], [1, 1, 0]], weight: 2 },
  { shape: [[1, 0], [1, 1], [0, 1]], weight: 2 },

  // Z-shapes
  { shape: [[1, 1, 0], [0, 1, 1]], weight: 2 },
  { shape: [[0, 1], [1, 1], [1, 0]], weight: 2 },

  // Corners
  { shape: [[1, 1], [1, 0]], weight: 3 },
  { shape: [[1, 1], [0, 1]], weight: 3 },
  { shape: [[0, 1], [1, 1]], weight: 3 },
  { shape: [[1, 0], [1, 1]], weight: 3 },
];

const totalWeight = PIECE_DEFINITIONS.reduce((sum, p) => sum + p.weight, 0);

let pieceIdCounter = 0;

export function generatePieces(count = 3, rng = Math.random) {
  const pieces = [];
  for (let i = 0; i < count; i++) {
    pieces.push(getRandomPiece(rng));
  }
  return pieces;
}

function getRandomPiece(rng = Math.random) {
  let random = rng() * totalWeight;
  let selected = PIECE_DEFINITIONS[0];

  for (const def of PIECE_DEFINITIONS) {
    random -= def.weight;
    if (random <= 0) {
      selected = def;
      break;
    }
  }

  const color = PIECE_COLORS[Math.floor(rng() * PIECE_COLORS.length)];

  return {
    id: ++pieceIdCounter,
    shape: selected.shape,
    color,
  };
}

export function getPieceSize(piece) {
  return {
    rows: piece.shape.length,
    cols: piece.shape[0].length,
  };
}

export function getPieceBlockCount(piece) {
  let count = 0;
  for (const row of piece.shape) {
    for (const cell of row) {
      if (cell) count++;
    }
  }
  return count;
}

export function seededRandom(seed) {
  return function () {
    seed = (seed * 16807) % 2147483647;
    return (seed - 1) / 2147483646;
  };
}
